import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  faPencil,
  faCloudArrowUp,
  faDeleteLeft,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { formDetails, profileFormData } from "../../../../slice/User";
import { imageUrl } from "../../../../slice/images";

import axios from "axios";
import { toast } from "react-toastify";
import lang from "../../../../assets/lang/toastMsg.json";
import image from "../../../../assets/lang/icons.json";
import style from "./profile.module.css";
import BodyLoading from "../../Loading/BodyLoading";
// import Pro from "./../../Pro/Pro";

const Profile = (props) => {
  const dispatch = useDispatch();
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const userImages = useSelector((state) => state.userImages);
  const userTemplate = useSelector((state) => state.userTemplate);
  const userData = useSelector((state) => state.user);

  const [bodyLoading, setBodyLoading] = useState(false);

  const [getUserTempid, setGetUserTempid] = useState("");

  const [categoryInput, setcategory] = useState({
    firstName: "",
    lastName: "",
    // title: "",
    companyName: "",
    department: "",
    mobile_number: "",
    website: "",
    email: "",
    address: "",

    instagram: "",
    facebook: "",
    twitter: "",
    linkedIn: "",
  });

  if (Object.values(categoryInput).every((el) => el === "")) {
    props = false;
  } else {
    props = true;
  }

  const handleInput = (e) => {
    e.preventDefault();

    setcategory({ ...categoryInput, [e.target.name]: e.target.value });
  };

  const imgref = useRef("");

  const [imgUrl, setImageUrl] = useState(
    isAuth
      ? getUserTempid && userTemplate.template[0].templateName !== "temp7"
        ? userImages.image[0].imageUrl
        : ""
      : localStorage.getItem("image")
      ? localStorage.getItem("image")
      : ""
  );

  const resetImage = async () => {
    if (!isAuth) {
      localStorage.removeItem("image");
      setImageUrl("");
    } else {
      try {
        const response = await axios.post("/img-delete");
        if (response.data.status === 200) {
          setImageUrl("");
          toast.info("Image Reset Successfully", {
            closeOnClick: true,
            theme: "colored",
          });
        } else {
          console.log(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const selectImage = () => {
    if (
      imgUrl === "" ||
      imgUrl === `${image.staticImage}` ||
      userTemplate.template[0].templateName === "temp7"
    ) {
      return (
        <div className={`${style.editImage}`}>
          <span className={`${style.editImgIcon} text-center text-dark`}>
            <FontAwesomeIcon color="black" icon={faCloudArrowUp} />
            <span className="d-block">upload Image</span>
          </span>
          <input
            type="file"
            name="image"
            onChange={handleimgInput}
            ref={imgref}
          ></input>
        </div>
      );
    } else {
      return (
        <div className={`${style.displayImg}`}>
          {isAuth ? (
            <img
              src={`${image.imageUrl}/${imgUrl}`}
              width={100}
              height={100}
              alt="noimg"
            />
          ) : (
            <img
              src={`${
                imgUrl === `${image.staticImage}`
                  ? `${image.imageUrl}/${imgUrl}`
                  : imgUrl
              }`}
              width={100}
              height={100}
              alt="noimg"
            />
          )}

          <div className="mt-2">
            <button className={`${style.btnReset}`} onClick={resetImage}>
              reset{"  "}
              <FontAwesomeIcon icon={faRotateRight} className=" text-white" />
            </button>
          </div>
        </div>
      );
    }
  };

  const handleimgInput = async (e) => {
    e.preventDefault();

    if (!isAuth) {
      if (!e.target.files[0].name.match(/\.(jpg|jpeg|png|gif)$/)) {
        toast.warn(`${lang.imageValid}`, {
          closeOnClick: true,
          theme: "colored",
        });
        return false;
      }

      const image = e.target.files[0];

      const reader = new FileReader();

      reader.readAsDataURL(image);

      reader.addEventListener("load", () => {
        localStorage.setItem("image", reader.result);

        setImageUrl(localStorage.getItem("image"));
      });
    } else {
      const formdata = new FormData();
      formdata.append("image", e.target.files[0]);

      if (!e.target.files[0].name.match(/\.(jpg|jpeg|png|gif)$/)) {
        toast.warn(`${lang.imageValid}`, {
          closeOnClick: true,
          theme: "colored",
        });
        return false;
      }

      try {
        setBodyLoading(true);
        const response = await axios.post("/img", formdata, {
          headers: { "Content-Type": "multipart/form-data " },
        });
        const res = await response.data;
        if (res.status === 200) {
          setImageUrl(response.data.imgUrl);
        }
        fetch();
        setBodyLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // function backendimg() {
  //   axios.get("/getUser").then((res) => {
  //     if (res.data.user[0].current_temp_id === "") {
  //       setImageUrl(res.data.user[0].image);
  //     }
  //   });
  // }

  const resetProfile = (e) => {
    e.preventDefault();
    setcategory({
      firstName: "",
      lastName: "",
      // title: "",
      companyName: "",
      department: "",
      mobile_number: "",
      website: "",
      email: "",
      address: "",

      instagram: "",
      facebook: "",
      twitter: "",
      linkedIn: "",
    });

    dispatch(formDetails(categoryInput));
    // dispatch(profileFormData(props));

    toast.dismiss();
    toast.info("Fields Reset Successfully", {
      closeOnClick: true,
      theme: "colored",
    });
  };

  const fetch = async () => {
    try {
      const response = await axios.get("/getUser");
      const user = await response.data.user;
      setGetUserTempid(user.current_temp_id);

      if (user.current_temp_id !== null) {
        const userdata = {
          firstName:
            user.edit_template.first_name !== null
              ? user.edit_template.first_name
              : "",
          lastName:
            user.edit_template.last_name !== null
              ? user.edit_template.last_name
              : "",
          // title:
          //   user.edit_template.title !== null ? user.edit_template.title : "",
          companyName:
            user.edit_template.company_name !== null
              ? user.edit_template.company_name
              : "",
          department:
            user.edit_template.department !== null
              ? user.edit_template.department
              : "",
          mobile_number:
            user.edit_template.mobile_number !== null
              ? user.edit_template.mobile_number
              : "",
          website:
            user.edit_template.website !== null
              ? user.edit_template.website
              : "",
          email:
            user.edit_template.temp_email !== null
              ? user.edit_template.temp_email
              : "",
          address:
            user.edit_template.address !== null
              ? user.edit_template.address
              : "",

          instagram:
            user.edit_template.instagram !== null
              ? user.edit_template.instagram
              : "",
          facebook:
            user.edit_template.facebook !== null
              ? user.edit_template.facebook
              : "",
          twitter:
            user.edit_template.twitter !== null
              ? user.edit_template.twitter
              : "",
          linkedIn:
            user.edit_template.linkedIn !== null
              ? user.edit_template.linkedIn
              : "",
        };
        setImageUrl(user.image);
        dispatch(imageUrl(user.edit_template.template_image));

        setcategory(userdata);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(formDetails(categoryInput));
    dispatch(imageUrl(imgUrl));

    dispatch(profileFormData(props));
  }, [categoryInput, imgUrl, dispatch, isAuth, props]);

  useEffect(() => {
    if (isAuth) {
      fetch();
    }
  }, [dispatch, isAuth]);

  return (
    <div className={`container text-start ${style.profileForm}`}>
      {bodyLoading ? <BodyLoading /> : null}
      <div className={`m-xxl-3 m-2`}>
        <span className=" custom-header">
          Enter Your Signature Details
          <button
            className={`btn btn-sm btn-outline-secondary ms-2 text-skyblue ${style.resetStyle}`}
            onClick={resetProfile}
          >
            <FontAwesomeIcon icon={faDeleteLeft} /> Clear Fields
          </button>
        </span>

        <div className="my-3 position-relative container-fluild">
          <div className="row">
            <div className="col-6">
              <label>Image</label>
              {selectImage()}
            </div>
          </div>
        </div>

        <div className="my-3 position-relative">
          <label className="custom-label">First Name</label>
          <input
            type="text"
            name="firstName"
            placeholder={`${image.placeHolder.firstName}`}
            autoComplete="off"
            value={categoryInput.firstName}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <div className="mb-3 position-relative">
          <label className="custom-label">Last Name</label>
          <input
            type="text"
            name="lastName"
            placeholder={`${image.placeHolder.lastName}`}
            autoComplete="off"
            value={categoryInput.lastName}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        {/* <div className="mb-3 position-relative">
          <label className="custom-label">Job Title</label>
          <input
            type="text"
            name="title"
            placeholder={`${image.placeHolder.title}`}
            autoComplete="off"
            value={categoryInput.title}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div> */}

        <div className="mb-3 position-relative">
          <label className="custom-label">Comapany Name</label>
          <input
            type="text"
            name="companyName"
            placeholder={`${image.placeHolder.companyName}`}
            autoComplete="off"
            value={categoryInput.companyName}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <div className="mb-3 position-relative">
          <label className="custom-label">Department</label>
          <input
            type="text"
            name="department"
            placeholder={`${image.placeHolder.department}`}
            autoComplete="off"
            value={categoryInput.department}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>
        <div className="mb-3 position-relative">
          <label className="custom-label">Mobile Phone Number</label>
          <input
            type="text"
            name="mobile_number"
            placeholder={`${image.placeHolder.mobile_number}`}
            autoComplete="off"
            value={categoryInput.mobile_number}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <div className="mb-3 position-relative">
          <label className="custom-label">Website URL</label>
          <input
            type="text"
            name="website"
            placeholder={`${image.placeHolder.website}`}
            autoComplete="off"
            value={categoryInput.website}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <div className="mb-3 position-relative">
          <label className="custom-label">Email Address</label>
          <input
            type="email"
            name="email"
            placeholder={`${image.placeHolder.email}`}
            autoComplete="off"
            value={categoryInput.email}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>
        <div className="mb-3 position-relative">
          <label className="custom-label">Address</label>
          <input
            type="text"
            name="address"
            placeholder={`${image.placeHolder.address}`}
            autoComplete="off"
            value={categoryInput.address}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <h4 className="my-4"> Enter Your Social Links</h4>

        <div className="mb-3 position-relative">
          <label className="custom-label">Facebook</label>
          <input
            type="text"
            name="facebook"
            placeholder={`${image.placeHolder.facebook}`}
            autoComplete="off"
            value={categoryInput.facebook}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <div className="mb-3 position-relative">
          <label className="custom-label">Instagram</label>
          <input
            type="text"
            name="instagram"
            placeholder={`${image.placeHolder.instagram}`}
            autoComplete="off"
            value={categoryInput.instagram}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <div className="mb-3 position-relative">
          <label className="custom-label">Linked In</label>
          <input
            type="text"
            name="linkedIn"
            placeholder={`${image.placeHolder.linkedIn}`}
            autoComplete="off"
            value={categoryInput.linkedIn}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>

        <div className="mb-3 position-relative">
          <label className="custom-label">Twitter</label>
          <input
            type="text"
            name="twitter"
            placeholder={`${image.placeHolder.twitter}`}
            autoComplete="off"
            value={categoryInput.twitter}
            onChange={handleInput}
          ></input>
          <span className={`${style.profileFormInputIcon}`}>
            <FontAwesomeIcon icon={faPencil} />
          </span>
        </div>
      </div>
    </div>
  );
};
export default Profile;
